import { api_update_profile_path } from '@routes';
import { AutocompleteOption, AutocompleteRecord } from '@utils/interfaces';

import request from './request';

export interface FirstPartyDataProps {
  company: AutocompleteRecord;
  companySize: AutocompleteOption;
  customIndustry: AutocompleteRecord;
  customJobFunction: AutocompleteRecord;
  customJobLevel: AutocompleteRecord;
  customSubIndustry: AutocompleteRecord;
  customSubJobFunction: AutocompleteRecord;
  industry: AutocompleteOption;
  jobFunction: AutocompleteOption;
  jobLevel: AutocompleteOption;
  postalCode: string;
  subIndustry: AutocompleteOption;
  subJobFunction: AutocompleteOption;
}

export interface ProfileParams {
  topics?: string[];
  interests?: string[];
}

export async function updateProfile(profile: ProfileParams): Promise<Record<string, never>> {
  const res = await request('post', api_update_profile_path({ profile: JSON.stringify(profile) }));
  return res;
}
